import { ComponentType } from "react";

// Visibility context passed to each card's visibility function
export interface CardVisibilityContext {
	isAuthenticated: boolean;
	hasPreferences: boolean;
	isBuyer: boolean;
	pageType: "search" | "sup" | "project";
}

// Props passed to each promotional card component
export interface PromotionalCardProps {
	className?: string;
}

// Configuration for each promotional card
export interface PromotionalCardConfig {
	id: string;
	component: ComponentType<PromotionalCardProps>;
	priority: number; // 1-10, higher = more likely to appear
	visibilityConditions: (context: CardVisibilityContext) => boolean;
	pages: ("search" | "sup" | "project")[];
}

// Card IDs for reference
export const PROMOTIONAL_CARD_IDS = {
	SUGGEST_FEATURE: "suggest-feature",
	TRY_PREFERENCES: "try-preferences",
	QUORA_REVIEW: "quora-review",
	EXPLORE_SERVICES: "explore-services",
	FACEBOOK_REVIEW: "facebook-review",
	GOOGLE_REVIEW: "google-review",
	INSTAGRAM: "instagram",
	DOWNLOAD_APP: "download-app",
	SCHEDULE_CALL: "schedule-call",
} as const;

// External URLs for review cards
export const REVIEW_URLS = {
	QUORA:
		"https://www.quora.com/unanswered/What-is-your-review-of-Settlin?ch=15&oid=221398361&share=6726157c&srid=uR2L2&target_type=question",
	FACEBOOK: "https://www.facebook.com/in.settlin/reviews",
	GOOGLE: "https://g.page/settlin-in",
} as const;

// Social media URLs
export const SOCIAL_URLS = {
	INSTAGRAM: "https://www.instagram.com/settlin_in/",
} as const;
